
<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }" ></ngx-loading>
<div class="row">
  <small class="text-center col-md-12">
    <b>  {{ translate.instant("protocolos.atribuirAtendente") }} - {{protocolo.id}}</b><br><hr>
  </small>
</div>
<div mat-dialog-content class="text-center">
  <span>{{ translate.instant("protocolos.selecioneAtendente") }}</span>
  <br><hr>
  <mat-form-field *ngIf="usuarios"  class="col-sm-12">
    <mat-select placeholder="Responsável" [(value)]="usuarioSelecionado" (selectionChange)="selecionarUsuario($event)" required>
      <mat-option *ngFor="let usuario of usuarios" [value]="usuario">
        {{usuario.name}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
<div mat-dialog-actions text-center>
  <button class="col-md-12" mat-raised-button color="primary" (click)="transferirAtendimento()"> {{ translate.instant("protocolos.atribuirAtendente") }} </button>
</div>